module.exports = __webpack_public_path__ + "static/media/apple-btn.af839c1b.png";